// @lib-generic-ui
import { useEffect } from "react";
import { useCollection } from "react-firebase-hooks/firestore";
import { useDispatch } from "react-redux";
import { collectionsActions } from "store/react-lib/generic-ui/collections";
import { snapshotToArray } from "utils/react-lib/generic-ui/firebaseUtils";

function CollectionLoader({ collectionName, query }) {
  
  const dispatch = useDispatch();
  const [snapshot, loading, error] = useCollection(query);

  useEffect(() => {
    const documents = snapshotToArray(snapshot);
    dispatch(
      collectionsActions.setCollectionState({
        collectionName,
        documents,
        loading,
        error: error?.message || "",
      })
    );
  }, [snapshot, loading, error]);

  return null;
}

export default CollectionLoader;
